import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Button, Row, Col, Portlet, Form } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

import ValidationSchema from './validation'
import * as FormGroups from './formGroups'

const RegistroProveedores = () => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      tipoReporte: '',
      tipoConsulta: ''
    }
  }, [])

  const clickSubmitDaot = React.useCallback(({ handleSubmit, setFieldValue }) => {
    setFieldValue('tipoConsulta', 'DAOT')
    handleSubmit()
  }, [])

  const clickSubmitAnual = React.useCallback(({ handleSubmit, setFieldValue }) => {
    setFieldValue('tipoConsulta', 'anual')
    handleSubmit()
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      __zariContext.loader.open('Descargando reporte.')

      const funcionSubmit =
        data.tipoConsulta === 'DAOT'
          ? () => AsientoContableService.descargarReporteRegistroProveedores(data)
          : () => AsientoContableService.descargarReporteRegistroProveedores(data)

      funcionSubmit()
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
          __zariContext.toast('success', 'Reporte descargado satisfactoriamente.')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
          setSubmitting(false)
        })
    },
    [__zariContext]
  )

  return (
    <Row>
      <Col md={6}>
        <Portlet>
          <Portlet.Header title='Registro Proveedores' />
          <Portlet.Body>
            <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
              {({ errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <Form>
                  <FormGroups.TipoReporteFormGroup
                    iError={errors.tipoReporte}
                    iTouched={touched.tipoReporte}
                    fIsSubmitting={isSubmitting}
                  />
                  <Row>
                    <Col md={12} className='text-right'>
                      <Button
                        tiny
                        disabled={isSubmitting}
                        onClick={() => clickSubmitDaot({ handleSubmit, setFieldValue })}
                      >
                        Reporte DAOT
                      </Button>
                      <Button
                        tiny
                        disabled={isSubmitting}
                        onClick={() => clickSubmitAnual({ handleSubmit, setFieldValue })}
                      >
                        Reporte Anual
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Portlet.Body>
        </Portlet>
      </Col>
    </Row>
  )
}

export default React.memo(RegistroProveedores)
